<template>
    <div>
        <splash-screen />
        <router-view />
    </div>
</template>

<script>
    import SplashScreen from './core/Components/SplashScreen.vue'
    import Splash from './core/Utils/splash-screen'

    export default {
        name: 'App',
        components: {SplashScreen},
        mounted() {
            this.$nextTick(function () {
                setTimeout(() => {
                    Splash.hide();
                }, 3000)
            });
        },
    }
</script>
